import { createContext, useReducer } from "react";

export const SustainabilityButtonsContext = createContext();

export const sustainabilityButtonsReducer = (state, action) => {
    switch (action.type) {
        case 'SET_SUSTAINABILITY_BUTTONS':
            return {
                sustainabilityButtons: action.payload
            }
        case 'CREATE_SUSTAINABILITY_BUTTONS':
            return {
                sustainabilityButtons: [action.payload, ...state.sustainabilityButtons]
            }
        case 'DELETE_SUSTAINABILITY_BUTTONS':
            return {
                sustainabilityButtons: state.sustainabilityButtons.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const SustainabilityButtonsContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(sustainabilityButtonsReducer, {
        sustainabilityButtons: null
    });

    return (
        <SustainabilityButtonsContext.Provider value={{ ...state, dispatch }}>
            {children}
        </SustainabilityButtonsContext.Provider>
    );
};